import React, { useEffect, useState } from "react";
import "./GroupLoansBalances.scss";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";

const GroupLoansBalances = ({ selectedLoan, setSelectedView }) => {
    const [loanBalances, setLoanBalances] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(()=>{
        getLoanGroupBalances();
    },[]);

    const columns = [
        {
            label: 'Group ID',
            getValue: (row) => row?.vloangroupbalances?.groupid ?? ''
        },
        {
            label: 'Curr Code',
            getValue: (row) => row?.vloangroupbalances?.currCode ?? ''
        },
        {
            label: 'Balance',
            getValue: (row) => row?.vloangroupbalances?.balance ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Unavailable Balance',
            getValue: (row) => row?.vloangroupbalances?.unavailablebalance ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Total Transactions',
            getValue: (row) => row?.vloangroupbalances?.totaltrans ?? ''
        },
        {
            label: 'PI ID',
            getValue: (row) => row?.vloangroupbalances?.piid ?? ''
        }
    ];

    const getLoanGroupBalances = async() => {
        try {
            // const response = await commonRunQuery(287, selectedLoan?.loangroups?.groupid ? selectedLoan?.loangroups?.groupid : selectedLoan?.lgm?.groupid);
            const response = await commonRunQuery(287, 11);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const groupsArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setLoanBalances(groupsArray);
              console.log("getLoanGroupBalances_response==========",groupsArray);
            } else {
                setLoanBalances([]);
            }
      
        } catch (error) {
            console.log("getLoanGroupBalances_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const formatedRows = (row) => columns.map((column) => column.getValue(row));

    return (
        <Box>
            <Box className="d-flex justify-content-between">
                <Typography
                sx={{
                    fontFamily: "'Nunito'",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "21.4825px",
                    color: "#3A3A3A",
                }}
                className=""
                >
                    Loan Balances
                </Typography>

                <Button
                    className="fs-size-12 paiy-blue text-white"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        setSelectedView(null);
                    }}
                >
                    Return
                </Button>
            </Box>

            {loading ? (
                    <Box
                        sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) :
                (
                    <Box className="mt-4">
                        <GroupLoansTable
                            data={loanBalances} 
                            columns={columns} 
                            title="Group Loan Balances" 
                            formatRow={formatedRows} 
                            viewMenu={false}
                            downloads={false}
                            // handleMenuOpen={handleMenuOpen}
                            // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                        />
                    </Box>
                )
            }
        </Box>
    )
}

export default GroupLoansBalances;
